import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=1ba33d24"
import script from "./DepartmentList.ts?vue&type=script&lang=ts&external"
export * from "./DepartmentList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports